import { useEffect, useRef } from "react";
import axiosInstance from "../../components/AxiosInstance";
import { useSnackbar } from "../../components/SnackBarProvider";
import isEqual from "lodash/isEqual";
import { DATA_COLLECTION_ID, SESSION_ID } from "../../constants";
import { checkRequiredFieldForDraft } from "../../scenes/SessionNote/SessionNoteCommon/DraftChecking";
import omit from "lodash/omit";
import { isDatasetEmptyOrNull } from "../../Phase2/GoalDataCollection/CheckValidValuetoSave";
export const useAutoSave = (
  values,
  addEndpoint,
  updateEndpoint,
  key,
  onAutoSaveSuccess
) => {
  const isSaving = useRef(false);
  const latestValues = useRef(values); // Store the latest values
  const { openSnackbar } = useSnackbar();

  const areAllAttemptsFilled = (data) => {
    const programTypeToDatasetMap = {
      Percentage: "percentDataSet",
      Duration: "durationDataSetList",
      "Task Analysis": "trialDataSetList",
      Frequency: "frequencyDataSet",
    };

    const datasetKey =
      programTypeToDatasetMap[data.goalDataCommon?.programType];
    const dataset = data[datasetKey];

    if (!dataset) return false; // If no dataset, return false

    const parsedDataset = JSON.parse(dataset);

    switch (data.goalDataCommon?.programType) {
      case "Percentage":
        return parsedDataset.every(
          (attempt) =>
            attempt.percent !== null &&
            attempt.percent !== "" &&
            (attempt.percent === 1 || attempt.prompt)
        );

      case "Task Analysis":
        return parsedDataset.every((group) =>
          group.trialDataList.every(
            (trial) =>
              trial.result !== null && trial.result !== "" && trial.prompt
          )
        );

      case "Duration":
        return parsedDataset.every((attempt) => attempt.duration !== 0);

      case "Frequency":
        return parsedDataset.every((attempt) => attempt.frequency > 0);

      default:
        return false;
    }
  };
  // Update the ref whenever values change
  useEffect(() => {
    console.log("values", values, "latest current", latestValues.current);
    latestValues.current = values;
    console.log("Updated values:", values);
  }, [values]);

  const saveData = async (data) => {
    //   if (isSaving.current) return;
    // console.log(data, JSON.parse(localStorage.getItem("lastSavedData"))); // Check parsed objects

    // console.log(
    //   JSON.stringify(data),
    //   " Difference ",
    //   isEqual(data, JSON.parse(localStorage.getItem("lastSavedData"))),
    //   localStorage.getItem("lastSavedData")
    // );
    console.log(
      data,
      "for saving",
      checkRequiredFieldForDraft(data, openSnackbar)
    );
    isSaving.current = true;
    const savedId = localStorage.getItem(key);
    if (savedId) {
      data.id = savedId;
    }
    if (key == SESSION_ID) {
      try {
        const latestValues = JSON.parse(JSON.stringify(data));
        const lastSavedData = JSON.parse(localStorage.getItem("lastSavedData"));

        // Fields to omit during comparison
        const fieldsToOmit = [
          "parentorgurdiansignaturefilename",
          "staffsignaturefilename",
          "supervisorsignaturefilename",
        ];

        // Remove the fields from both objects
        const filteredLatestValues = omit(latestValues, fieldsToOmit);
        const filteredLastSavedData = omit(lastSavedData, fieldsToOmit);
        console.log(
          JSON.stringify(filteredLatestValues) ===
            JSON.stringify(filteredLastSavedData),
          "checking value"
        );
        Object.keys(filteredLatestValues).forEach((key) => {
          if (filteredLatestValues[key] !== filteredLastSavedData[key]) {
            console.log(
              `Mismatch at key "${key}":`,
              filteredLatestValues[key],
              filteredLastSavedData[key]
            );
          }
        });
        console.log(filteredLatestValues, "LATEST VALUES (filtered)");
        console.log(filteredLastSavedData, "LAST SAVED DATA (filtered)");

        if (isEqual(filteredLatestValues, filteredLastSavedData)) {
          return;
        }
      } catch (err) {
        console.log(err);
      }
    }
    if (key === DATA_COLLECTION_ID) {
      // Map programType to its corresponding dataset key
      const programTypeToDatasetMap = {
        Percentage: "percentDataSet",
        Duration: "durationDataSetList",
        "Task Analysis": "trialDataSetList",
        Frequency: "frequencyDataSet",
      };

      const datasetKey =
        programTypeToDatasetMap[
          latestValues.current.goalDataCommon.programType
        ];
      const datasetString = data[datasetKey];

      // Check if the relevant dataset is empty or null
      if (isDatasetEmptyOrNull(datasetString)) {
        console.log(
          `Skipping API call: ${datasetKey} is empty or all values are null for programType: ${data.goalDataCommon.programType}`
        );
        isSaving.current = false;
        return; // Exit early
      }
    }
    const endpoint = savedId ? updateEndpoint : addEndpoint;
    if (
      !isEqual(data, JSON.parse(localStorage.getItem("lastSavedData"))) &&
      !(key == SESSION_ID && checkRequiredFieldForDraft(data, openSnackbar))
    ) {
      try {
        console.log(`Auto-saving to ${endpoint}...`, data);
        const response = await axiosInstance.post(endpoint, data);

        // If the response contains an ID (new entry created), update the ref
        if (response.data[0]?.sessionId) {
          localStorage.setItem(key, response.data[0].sessionId);
          localStorage.setItem(
            "lastSavedData",
            JSON.stringify({ ...data, id: "" + response.data[0].sessionId })
          );
        }
        if (response.data[0]?.id) {
          localStorage.setItem(key, response.data[0].id);
          localStorage.setItem(
            "lastSavedData",
            JSON.stringify({ ...data, id: "" + response.data[0].id })
          );
        }
        // openSnackbar("Saved Sucessfully", "success");
        console.log("Auto-save successful:", response.data);
        // Trigger the callback to notify about successful auto-save
        if (onAutoSaveSuccess && areAllAttemptsFilled(data)) {
          onAutoSaveSuccess(data.goalDataCommon.goalId);
        }
      } catch (error) {
        //openSnackbar(error, "error");

        console.error("Auto-save failed:", error);
      } finally {
        isSaving.current = false;
      }
    }
  };

  useEffect(() => {
    // Start auto-save every 5 seconds
    const interval = setInterval(() => {
      saveData(latestValues.current); // Always send the latest values
    }, 5000); // 5000ms = 5 sec

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, [addEndpoint, updateEndpoint]); // No need to watch `values` here
};
